module.exports = __webpack_public_path__ + "fonts/fa-solid-900.418dad8.woff2";